// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"264":"1b039702","452":"7094ffc3","580":"3e4a103b","599":"56e85294"}[chunkId] + ".chunk.js";
};